module.exports = __webpack_public_path__ + "static/media/Medcare Medical Centre JBR.38dfab06.jpg";